import feature from "@/guards/feature";
import acl from "@/guards/acl";

export default {
  guards: {
    acl,
    feature,
  },
};
